import React, { useState, useEffect } from "react";
import { axiosInstance } from "../helper/axiosInstance";

const Users = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await axiosInstance.get("/users");

                // Parse the `data` field of each user
                const parsedUsers = response.data.map(user => ({
                    ...user,
                    data: JSON.parse(user.data.replace(/'/g, '"')) // Convert single quotes to double quotes and parse
                }));

                setUsers(parsedUsers);
                setLoading(false);
            } catch (err) {
                console.error("Error fetching users:", err);
                setError("Failed to fetch users.");
                setLoading(false);
            }
        };

        fetchUsers();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div>
            <h2>Users</h2>
            <ul>
                {users.map(user => (
                    <li key={user.id}>
                        <strong>{user.data.name}</strong> - {user.email || "No email"}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Users;